import { ANALYTICS } from './constants';
import {
  AnalyticClickedDetailsType,
  AnalyticClickedLinkDetailsType,
  AnalyticConversationStartedType,
  AnalyticErrorShownDetailsType,
  AnalyticInactivityShownDetailsType,
  AnalyticFormErrorDetailsType,
  AnalyticFormSubmittedDetailsType,
  AnalyticQuickReplyDetailsType,
  AnalyticToastShownDetailsType,
  AnalyticTimeElapsedDetailsType,
  AnalyticReconnectedDetailsType,
} from './types';

/***
 * `details` object should only contain flattened properties in snake_case. Per analytics team request.
 */
export const customAttributesMapper: { [k: string]: any } = {
  [ANALYTICS.EVENT.CHAT_OPENED]: () => ({}),
  [ANALYTICS.EVENT.CHAT_CLOSED]: () => ({}),
  [ANALYTICS.EVENT.CHAT_RECONNECTED]: (details: AnalyticReconnectedDetailsType) => details,
  [ANALYTICS.EVENT.CLICKED]: (details: AnalyticClickedDetailsType) => details,
  [ANALYTICS.EVENT.CLICKED_LINK]: (details: AnalyticClickedLinkDetailsType) => details,
  [ANALYTICS.EVENT.CONVERSATION_STARTED]: (details: AnalyticConversationStartedType) => details,
  [ANALYTICS.EVENT.ERROR_MESSAGE_SHOWN]: (details: AnalyticErrorShownDetailsType) => details,
  [ANALYTICS.EVENT.INACTIVITY_SHOWN]: (details: AnalyticInactivityShownDetailsType) => details,
  [ANALYTICS.EVENT.FORM_FAILED]: (details: AnalyticFormErrorDetailsType) => details,
  [ANALYTICS.EVENT.FORM_SUBMITTED]: (details: AnalyticFormSubmittedDetailsType) => details,
  [ANALYTICS.EVENT.QUICK_REPLY]: (details: AnalyticQuickReplyDetailsType) => details,
  [ANALYTICS.EVENT.TOAST_SHOWN]: (details: AnalyticToastShownDetailsType) => details,
  [ANALYTICS.EVENT.TIME_ELAPSED]: (details: AnalyticTimeElapsedDetailsType) => details,
  [ANALYTICS.EVENT.VIEW_DISPLAYED]: () => ({}),
};
